var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","overflow":"hidden"},attrs:{"id":"app"}},[_c('side-nav'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"header"}},[_c('img',{attrs:{"alt":"Lalamove logo","src":require("./assets/logo.png")}}),_c('h1',[_vm._v("Welcome to Lalamove+ Back Office Panel")])])
}]

export { render, staticRenderFns }